import { getFunnelPaths } from "routes/adFunnel";

export type MktVersionTypes = "v4";
// v4 퍼널은 광고 채널별 두 prefix(/promotion-*, /gads-*)에서 동일하게 돌므로 현재 경로의 prefix 를 따른다.
export function versionToPathPrefix(version: MktVersionTypes) {
  if (version === "v4") return getFunnelPaths().prefix;
  return `${version}`;
}
